import { Colors } from 'goalsetter-webapp-components';

export const cardStyle = (color?: string, isMobile?: boolean) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  height: '80px',
  width: '100%',
  padding: isMobile ? '0 8px' : '0 32px',
  background: color || Colors.WHITE,
});

export const avatarContainerStyle = { gap: '16px', flex: 1 };
export const buttonStyle = { minWidth: '100px' };
